"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _guacWidgetCore = require("@wsb/guac-widget-core");

var _serviceLocationTypes = _interopRequireDefault(require("../../constants/serviceLocationTypes"));

var _LocationUrl = _interopRequireDefault(require("./LocationUrl"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ServiceLocation = function ServiceLocation(_ref) {
  var isServiceBooked = _ref.isServiceBooked,
      i18n = _ref.i18n,
      locationType = _ref.locationType,
      formattedAddress = _ref.formattedAddress,
      customLocationText = _ref.customLocationText,
      locationUrl = _ref.locationUrl,
      locationUrlNotes = _ref.locationUrlNotes,
      onLocationUrlMount = _ref.onLocationUrlMount,
      onLocationUrlClick = _ref.onLocationUrlClick;
  var _UX2$Element = _guacWidgetCore.UX2.Element,
      Text = _UX2$Element.Text,
      Details = _UX2$Element.Details;

  if (locationType === _serviceLocationTypes["default"].ONLINE) {
    if (isServiceBooked) {
      var urlLine;

      if (locationUrl) {
        urlLine = /*#__PURE__*/_react["default"].createElement(_LocationUrl["default"], {
          locationUrl: locationUrl,
          onMount: onLocationUrlMount,
          onClick: onLocationUrlClick
        });
      } else {
        urlLine = /*#__PURE__*/_react["default"].createElement(Text, null, i18n.nullTeleconferenceUrl);
      }

      return /*#__PURE__*/_react["default"].createElement(Details, null, urlLine, locationUrlNotes && /*#__PURE__*/_react["default"].createElement(Text, null, locationUrlNotes));
    }

    return /*#__PURE__*/_react["default"].createElement(Details, null, i18n.onlineVirtual);
  }

  if (locationType === _serviceLocationTypes["default"].CUSTOM) {
    return customLocationText && customLocationText.split('\n').map(function (item, index) {
      return /*#__PURE__*/_react["default"].createElement(Details, {
        key: index
      }, item);
    });
  }

  return formattedAddress.map(function (line, index) {
    return /*#__PURE__*/_react["default"].createElement(Details, {
      key: index
    }, line);
  });
};

ServiceLocation.propTypes = {
  isServiceBooked: _propTypes["default"].bool,
  locationType: _propTypes["default"].string.isRequired,
  formattedAddress: _propTypes["default"].object.isRequired,
  customLocationText: _propTypes["default"].string,
  locationUrl: _propTypes["default"].string,
  locationUrlNotes: _propTypes["default"].string,
  i18n: _propTypes["default"].shape({
    onlineVirtual: _propTypes["default"].string,
    nullTeleconferenceUrl: _propTypes["default"].string
  }).isRequired,
  onLocationUrlMount: _propTypes["default"].func,
  onLocationUrlClick: _propTypes["default"].func
};
var _default = ServiceLocation;
exports["default"] = _default;